import React from 'react';
import PropTypes from 'prop-types';

import CardsTableRow from './CardsTableRow';
import CardsTableHeader from './CardsTableHeader';
import TableFooter from 'components/helpers/TableFooter';
import { tableNoResultsDefault, tableSpinnerDefault } from 'components/helpers/TableHelpers';

const COLUMN_COUNT = 6;

export default class CardsTable extends React.Component {
  static propTypes = {
    cards: PropTypes.arrayOf(PropTypes.object).isRequired,
    allowSend: PropTypes.bool.isRequired,
    meta: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onPageChange: PropTypes.func.isRequired,
    onCardSend: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);

    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleCardSend = this.handleCardSend.bind(this);
  }

  render() {
    const {allowSend} = this.props;

    return (
      <div className='u-margin-bottom--gutter2x'>
        <div className='table-scroll'>
          <table className='o-table o-table--bordered'>
            <CardsTableHeader showActions={allowSend}/>
            <tbody>
              { this.renderBody() }
            </tbody>
          </table>
        </div>
        { this.renderFooter() }
      </div>
    );
  }

  renderBody() {
    if (this.isLoading()) {
      return this.renderLoading();
    }

    if (this.emptyResults()) {
      return this.renderEmptyResults();
    }

    return this.renderRows();
  }

  isLoading() {
    const { cards, isLoading } = this.props;

    return cards.length === 0 && isLoading;
  }

  renderLoading() {
    return tableSpinnerDefault(COLUMN_COUNT);
  }


  emptyResults() {
    const { cards, meta: { totalPages }} = this.props;
    return cards.length === 0 && totalPages === 0;
  }

  renderEmptyResults() {
    return tableNoResultsDefault(COLUMN_COUNT);
  }

  renderRows() {
    const { cards, allowSend } = this.props;

    return cards.map(card => (
      <CardsTableRow
        key={`${card.id}`}
        card={card}
        allowSend={allowSend}
        onSendClick={this.handleCardSend}
      />
    ));
  }

  handleCardSend(card) {
    this.props.onCardSend(card);
  }

  renderFooter() {
    const { meta } = this.props;

    if (!meta.totalCount || meta.totalCount === 0) return null;

    return (
      <TableFooter meta={meta} onPageChange={this.handlePageChange}/>
    );
  }

  handlePageChange(page) {
    this.props.onPageChange(page);
  }
}
